// App Config
import BackboneApi from '../../../services/BackboneApi';
import WtfApi from '../../../services/WtfApi';
import ImageService from '../../../services/ImageService';

/**
 * ResultService
 * - It will get the image crop data for the result component.
 */
class ResultService {
  constructor(appConfig) {
    /**
     * Instance of the Image service.
     * @type {ImageService}
     */
    this.imageService = new ImageService();

    /**
     * Instance of the wtf Api.
     * @type {WtfApi}
     */
    this.wtfApi = new WtfApi();

    /**
     * Instance of the Backbone Api.
     * @type {BackboneApi}
     */
    this.backboneApi = new BackboneApi();

    /**
     * The maximum amount of results retrieved from the server
     */
    this.resultsLimit = appConfig.resultsLimit;

    /**
     * Default value of experiment data
     */
    this.experimentData = {};
  }

  /**
   * It gets from the BE the image crop data.
   * @param  {String} base64ImageData image.
   * @return {Promise}
   */
  getImageCropResultsFromApi(base64Image) {
    // RegExp to capture the encoded data and the mime type from a dataURI
    const dataURIregEx = /:([a-zA-Z0-9_-]+\/[a-zA-Z0-9_-]+);base64,(.{1,})/;
    // Assign the encoded data to the body's image property.
    const body = {
      image: base64Image.match(dataURIregEx)[2],
      experimentData: this.experimentData,
      md5: this.md5,
      annotationIndex: this.annotationIndex,
      platform: 'Store',
    };

    return this.wtfApi.getImageCropResults({ limit: this.resultsLimit }, body);
  }

  /**
   * It prepares the imageUrl for the request and then get the image crop data from the BE.
   * @param  {String} croppedImageUrl cropped object url image.
   * @return {Promise}
   */
  getCropResults(croppedImageUrl, experimentData, md5, annotationIndex) {
    try {
      this.experimentData = JSON.parse(experimentData);
      this.md5 = md5;
      this.annotationIndex = annotationIndex;
    } catch (err) {
      // eslint-disable-next-line no-console
      console.warn(err);
    }

    return ImageService.getImageBlobFromImageUrl(croppedImageUrl)
      .then(this.imageService.getImageBase64.bind(this))
      .then(this.getImageCropResultsFromApi.bind(this));
  }
}

export default ResultService;



// WEBPACK FOOTER //
// ./src/components/Result/services/ResultService.js